/**
 * 字符串处理类
 */
export default class StringUtil {
  /**
   * 是否空值
   * @param val 
   * @returns 
   */
  public static isEmpty(val: any): boolean {
    // null or undefined
    if (val === null || val === undefined) return true;
  
    if (typeof val == 'boolean') return false;
    
    if (val instanceof Error) return val.message === '';
  
    switch (Object.prototype.toString.call(val)) {
      // String or Array
      case '[object String]':
      case '[object Array]':
        return !val.length;
      // Map or Set or File
      case '[object File]':
      case '[object Map]':
      case '[object Set]': {
        return !val.size;
      }
      // Plain Object
      case '[object Object]': {
        return !Object.keys(val).length;
      }
    }
  
    return false;
  }

  //时间转时间戳
  public static timestampToTime(times: string | number, format: string) {
    const timestamp = parseInt(times + "");

    if (StringUtil.isEmpty(times) || timestamp == 0) {
        return "无";
    }

    const jsdate = ((timestamp) ? new Date(timestamp) : new Date()); 
    
    const tf = (i: number) => {return (i < 10 ? '0' : '') + i};  

    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a: string): string {  
        switch(a){  
            case 'yyyy':  
                return tf(jsdate.getFullYear());  
            case 'MM':  
                return tf(jsdate.getMonth() + 1);  
            case 'mm':  
                return tf(jsdate.getMinutes());
            case 'dd':  
                return tf(jsdate.getDate());
            case 'HH':  
                return tf(jsdate.getHours());
            case 'ss':  
                return tf(jsdate.getSeconds());
            default:
              return "";
        }
    })
  }
}